import getOs from '~utils/common/getOs';

/**
 * 운영체제에 따른 codef 설치파일 경로 반환
 * @returns
 */
export default function getCodefDownloadPath() {
  const os = getOs();

  if (os === 'windows') {
    return '/codef/CodefCertInstaller.exe';
  }

  return '/codef/codefCertMac.dmg';
}
